import searchService from '../../../../ml/services/searchService';

const state = {
  layout: 'detail',
  results: null,
}

const getters = {
  layout: state => state.layout,
  results: state => state.results,
}

const mutations = {
  setLayout(state, layout) {
    state.layout = layout;
  },
  setResults(state, results) {
    state.results = results;
  },
}

const actions = {
  setLayout({commit}, layout) {
    commit('setLayout', layout);
  },
  search({commit}, form) {
    return searchService.searchPresentations(form)
      .then(data => {
        commit('setResults', data);
        return data;
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
